import quickInput from './quickInput/quickInput'
import quickButton from './quickButton/quickButton'
import quickRadio from './quickRadio/quickRadio'
import quickRadioItem from './quickRadio/quickRadioItem'

export default [
	quickInput,
	quickButton,
	quickRadio,
	quickRadioItem,
]


// WEBPACK FOOTER //
// ./src/components/index.js